import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    next: 'Confirm my PIN code',
    pinConfirmationMismatched:
      'The two PIN codes are not the same. Please enter it again.',
    sidebarImgAlt: 'Set the PIN code for your card',
    subtitle:
      'Create a secret code to secure your transactions with this card.',
    title: 'Set the PIN code for your card',
  },
  fr: {
    next: 'Confirmer mon code PIN',
    pinConfirmationMismatched:
      'Les deux codes PIN ne sont pas identiques. Veuillez le saisir une nouvelle fois.',
    sidebarImgAlt: 'Choisissez le code PIN de votre carte',
    subtitle:
      'Créez un code secret pour sécuriser vos opérations avec cette carte.',
    title: 'Choisissez le code PIN de votre carte',
  },
} as const);

export default locales;
